/**
 * sw-pr-gw-customer-dashboard
 * SpendWyze Payment Request Gateway Customer Dashboard
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PaymentRequestTaskPayer } from './paymentRequestTaskPayer';

export interface PaymentRequestTaskPayee {
    /**
     * The name of the transaction's payee.
     */
    name: string;
    /**
     * The account number of the transaction's payee.
     */
    accountNumber: string;
}

export interface PaymentRequestTask { 
    /**
     * The unique identifier of the task
     */
    id: string;
    /**
     * Creation date time of the payment request task
     */
    creationDateTime: Date;
    /**
     * Type of the payment request task
     */
    type: PaymentRequestTask.TypeEnum;
    /**
     * The date till the transaction can be accepted or declined.
     */
    validityDate?: Date;
    /**
     * the date till the transaction should be accepted or declined.
     */
    deadline?: Date;
    payee?: PaymentRequestTaskPayee;
    payer?: PaymentRequestTaskPayer;
    /**
     * The amount of the transaction.
     */
    amount?: number;
    /**
     * The flag specifies if the amount can be modified or not.
     */
    amountModifiable?: boolean;
    /**
     * The comment of the transaction.
     */
    comment?: string;
    /**
     * The flag specifies if the comment can be modified or not.
     */
    commentModifiable?: boolean;
    status: PaymentRequestTask.StatusEnum;
    /**
     * The payment request task is recallable or not
     *
     * ### RECALLABLE
     *
     * The status of the payment request task is
     *
     * - INITIATED
     * - DATA_INPUT_STARTED
     * - CONFIRMATION_STARTED
     * - READY_TO_SEND
     * - ACCEPTED_BY_GIRO
     *
     * ### RECALL_IS_IN_PROGRESS
     *
     * - READY_TO_SEND_RECALL
     * - WAITING_FOR_RECALL_GIRO_ACK
     * - WAITING_FOR_RECALL_GIRO_ACCEPT
     *
     * ### WAITING_FOR_GIRO
     *
     * The status of the payment request task is
     *
     * - WAITING_FOR_GIRO_ACK
     * - WAITING_FOR_GIRO_ACCEPT
     *
     * ### NON_RECALLABLE
     *
     * The status of the payment request task is
     *
     * - REJECTED_BY_GIRO
     * - DECLINED
     * - EXPIRED
     * - COMPLETED
     * - RECALL_ACK_REJECTED_BY_GIRO
     * - RECALL_REJECTED_BY_GIRO
     * - RECALLED
     * @example "RECALLABLE"
     */
    recallStatus: "RECALLABLE" | "RECALL_IS_IN_PROGRESS" | "WAITING_FOR_GIRO" | "NON_RECALLABLE";
}
export namespace PaymentRequestTask {
    export type TypeEnum = 'PAYMENT_REQUEST_UNATTENDED' | 'PAYMENT_REQUEST_PAYER_ATTENDED';
    export const TypeEnum = {
        UNATTENDED: 'PAYMENT_REQUEST_UNATTENDED' as TypeEnum,
        PAYERATTENDED: 'PAYMENT_REQUEST_PAYER_ATTENDED' as TypeEnum
    };
    export type StatusEnum = 'CONFIRMATION_NEEDED' | 'PROCESSING' | 'ACCEPTED_BY_GIRO' | 'REJECTED_BY_GIRO' | 'EXPIRED' | 'DECLINED' | 'COMPLETED' | 'RECALL_PROCESSING' | 'RECALL_REJECTED_BY_GIRO' | 'RECALLED';
    export const StatusEnum = {
        CONFIRMATIONNEEDED: 'CONFIRMATION_NEEDED' as StatusEnum,
        PROCESSING: 'PROCESSING' as StatusEnum,
        ACCEPTEDBYGIRO: 'ACCEPTED_BY_GIRO' as StatusEnum,
        REJECTEDBYGIRO: 'REJECTED_BY_GIRO' as StatusEnum,
        EXPIRED: 'EXPIRED' as StatusEnum,
        DECLINED: 'DECLINED' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        RECALLPROCESSING: 'RECALL_PROCESSING' as StatusEnum,
        RECALLREJECTEDBYGIRO: 'RECALL_REJECTED_BY_GIRO' as StatusEnum,
        RECALLED: 'RECALLED' as StatusEnum
    };
}